import { types } from "../types/types";

const initialState = {
  loading: false,
  managerConfigs: [],
  validatorConfigs: [],
  editorConfigs: []
};

export const flowModuleConfigReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_MODULE_CONFIG_START_LOADING:
      return { ...state, loading: action.payload };
    case types.FLOW_MODULE_CONFIG_SET_MANAGERS:
      return { ...state, managerConfigs: action.payload };
    case types.FLOW_MODULE_CONFIG_SET_VALIDATORS:
      return { ...state, validatorConfigs: action.payload };
    case types.FLOW_MODULE_CONFIG_SET_EDITORS:
      return { ...state, editorConfigs: action.payload };
    default:
      return state;
  }
};
